import React, { useState } from "react";
import { FiTarget, FiFileText, FiList } from "react-icons/fi";

import Spec from "./spec";
import ScoringMethods from "./scoring-methods";

const Qualification = () => {
  const [activeTab, setActiveTab] = useState("scoring");

  const tabs = [
    { id: "scoring", label: "Scoring Methods", icon: FiList },
    { id: "spec", label: "Specification", icon: FiFileText },
  ];

  return (
    <div className="h-full flex flex-col">
      {/* Header with Tabs */}
      <div className="bg-white border-b border-gray-200 px-6 pt-6">
        <div className="flex items-center gap-2 mb-4">
          <FiTarget className="w-6 h-6 text-purple-600" />
          <h1 className="text-2xl font-bold text-gray-900">AI Qualification</h1>
        </div>
        
        {/* Tabs */}
        <div className="flex gap-1">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-t-lg transition-colors ${
                  isActive
                    ? "bg-gray-100 text-purple-600 border-b-2 border-purple-600"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-auto bg-gray-50">
        {activeTab === "scoring" && <ScoringMethods />}
        {activeTab === "spec" && <Spec />}
      </div>
    </div>
  );
};

export default Qualification;
